import { render } from "./QwilrForm.vue?vue&type=template&id=65a1f410&ts=true"
import script from "./QwilrForm.vue?vue&type=script&lang=ts"
export * from "./QwilrForm.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__